export default __webpack_public_path__ + "static/media/Amaro.d60221db.png";